import React from 'react';
import styled from 'styled-components';

function Button({ title, handleClick }) {
  return (
    <ButtonContainer
      className='d-flex flex-row pt-3 align-items-end'
      onClick={handleClick}
    >
      <UserBtn className='w-100 btn btn-primary'>{title}</UserBtn>
    </ButtonContainer>
  );
}

const ButtonContainer = styled.div`
  height: 150px;
`;
const UserBtn = styled.button`
  height: 69px;
`;

export default Button;
